module.exports = __webpack_public_path__ + "static/media/Intersect.29eb7ade.png";